import "./index.scss";
import Date from "./Date";
import Birthday from "./Birthday";
import DateRange from "./DateRange";
import DateInline from "./DateInline";
import MultipleInlineCalendar from "./MultipleInlineCalendar";
import MultipleDropdownCalendar from "./MultipleDropdownCalendar";

const Picker: {
  Date: typeof Date;
  Birthday: typeof Birthday;
  DateRange: typeof DateRange;
  DateInline: typeof DateInline;
  MultipleInline: typeof MultipleInlineCalendar;
  MultipleDropdown: typeof MultipleDropdownCalendar;
} = Object.assign(
  {},
  {
    Date,
    DateRange: DateRange,
    DateInline,
    Birthday,
    MultipleInline: MultipleInlineCalendar,
    MultipleDropdown: MultipleDropdownCalendar,
  }
);

export default Picker;
